import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import {
  useGetList,
  useRecordContext,
} from 'react-admin';
import SnapshotComponent from './SnapshotComponent';
import Snapshot from '../../../utilities/schemas/Snapshot';

const SnapshotList = () => {
  const record = useRecordContext();
  const { data: snapshots, isLoading: isLoadingSnapshots } = useGetList<Snapshot>(
    `cases/${record?.id}/transaction-snapshot`,
  );

  if (isLoadingSnapshots) return null;
  if (!snapshots) {
    return (
      <Box padding={2}>
        <Typography align="center">No Snapshots available</Typography>
      </Box>
    );
  }

  return snapshots.map((snapshot) => <SnapshotComponent snapshot={snapshot} key={snapshot.id} />);
};

export default SnapshotList;
